import React from "react";
import { DefaultButton, Stack, Text } from "@fluentui/react";


const ErrorFallback = ({ error, resetErrorBoundary }) => {
    return (
        <Stack
          verticalAlign="center"
          horizontalAlign="center"
          verticalFill
          style={{ height: "100vh", textAlign: "center", padding: 20 }}
          tokens={{ childrenGap: 20 }}
        >
          <Text variant="xxLargePlus">Oops! Something went wrong.</Text>
          <Text variant="mediumPlus" style={{ color: "red" }}>
            {error?.message || "An unexpected error occurred."}
          </Text>
          <DefaultButton text="Try again" style={{alignSelf:'auto'}} onClick={resetErrorBoundary} />
        </Stack>
      );
    };

export default ErrorFallback;

